var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"download":_vm.downloadName,"href":_vm.downloadUrl,"disabled":!this.data || this.data.length === 0}},[_vm._t("default",[_c('i',{staticClass:"fa fa-file-excel-o",attrs:{"aria-hidden":"true"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }